import { PersonaPickerOption } from '@sdk/components/forms/personaPickers/PersonaPicker/personaPicker.types';
import { User } from '@sdk/users/types/User';
import { mapPersonaToPickerOption } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/groupedPersonaPicker.utils';

export const getEmployeeOptions = (users: User[]): PersonaPickerOption[] =>
  users.map(mapPersonaToPickerOption);
